import { render, staticRenderFns } from "./BCXButton.vue?vue&type=template&id=480ce450&scoped=true"
import script from "./BCXButton.vue?vue&type=script&lang=ts"
export * from "./BCXButton.vue?vue&type=script&lang=ts"
import style0 from "./BCXButton.vue?vue&type=style&index=0&id=480ce450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ce450",
  null
  
)

export default component.exports